<div class="login-container" *ngIf="passwordChangeRequired == false && passwordResetRequired == false">
    <form (submit)="onSignIn(signInForm)" #signInForm="ngForm">
        <h2 style="text-align: center;">Login</h2>
        <p>
            <mat-form-field class="login-input-width">
                <mat-label>Email address</mat-label>
                <input name="email" matInput ngModel type="email" #emailInput="ngModel" [(ngModel)]="email_address" email
                    placeholder="Enter Username" required>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field class="login-input-width">
                <mat-label>Password</mat-label>
                <input [(ngModel)]="password" matInput ngModel type="password" minlength="8" #passwordInput="ngModel"
                    required name="password" placeholder="Enter Password" />
                    <mat-hint align="end"><a routerLink="/forgot-password" routerLinkActive="active">Forgot Password</a></mat-hint>
            </mat-form-field>
        </p>
        <p>
            <button type="submit" mat-raised-button color="primary">Login</button>
        </p>
    </form>
</div>
<div class="login-container" *ngIf="passwordChangeRequired == true">
    <form (submit)="onChangePassword(passwordChangeForm)" #passwordChangeForm="ngForm">
        <h2 style="text-align: center;">Set Password</h2>
        <p>You are required to set a new password to log in.</p>
        <p>
            <mat-form-field class="login-input-width">
                <mat-label>New Password</mat-label>
                <input [(ngModel)]="newPassword" matInput ngModel type="password" minlength="8" #passwordInput="ngModel"
                    required name="newPassword" placeholder="Enter New Password">
            </mat-form-field>
        </p>
        <p>
            <button type="submit" mat-raised-button color="primary">Change Password</button>
        </p>
    </form>
</div>

<div class="login-container" *ngIf="passwordResetRequired == true">
    <form (submit)="onResetPassword(passwordResetForm)" #passwordResetForm="ngForm">
        <h2 style="text-align: center;">Password Reset</h2>
        <p>You are required to reset your password to log in.</p>
        <p>
            <mat-form-field class="login-input-width">
                <mat-label>Verification Code</mat-label>
                <input [(ngModel)]="verificationCode" matInput ngModel type="text" minlength="1" #textInput="ngModel"
                    required name="verificationCode" placeholder="Enter New Password">
            </mat-form-field>
        </p>
        <p>
            <mat-form-field class="login-input-width">
                <mat-label>New Password</mat-label>
                <input [(ngModel)]="resetPassword" matInput ngModel type="password" minlength="8" #passwordInput="ngModel"
                    required name="resetPassword" placeholder="Enter New Password">
            </mat-form-field>
        </p>
        <p>
            <button type="submit" mat-raised-button color="primary">Change Password</button>
        </p>
    </form>
</div>